import { HappyStorie } from "../../../../types/marriageSevices";
import HappyStoriesSlider from "./HappyStoriesSlider";

interface Props {
  data?: HappyStorie;
}

const HappyStories: React.FC<Props> = ({ data }) => {
  return (
    <>
      <section className="py-0 py-md-5">
        <div className="container">
          <div className="row">
            <div className="hd-style-2 golden wow animate__fadeInLeft">
              <div
                className="mb-5 font-35 ff-bold"
                dangerouslySetInnerHTML={{
                  __html: data?.heading ?? "",
                }}
              />
            </div>
            <HappyStoriesSlider data={data} />
          </div>
        </div>
      </section>
    </>
  );
};

export default HappyStories;
